import axios from 'axios';

export const extractS3KeyFromPresignedUrl = (presignedUrl: string): string => decodeURIComponent(new URL(presignedUrl).pathname).replace(/^\//, '');

export const fileOpen = async (cdnLink?: string, fileName?: string) => {
  if (!cdnLink || !fileName) return;

  await fetch(cdnLink)
    .then((res) => {
      return res.blob();
    })
    .then((blob) => {
      const anchor = document.createElement('a');
      anchor.href = URL.createObjectURL(blob);
      anchor.download = fileName + '.pdf';
      anchor.click();
    });
};

export const readFile = (file: File | string): Promise<ArrayBuffer> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      if (e.target?.result instanceof ArrayBuffer) {
        resolve(e.target.result);
      }
    };
    reader.onerror = (e) => {
      reject(e);
    };
    if (file instanceof File) {
      reader.readAsArrayBuffer(file);
    } else {
      fetch(file)
        .then((response) => response.blob())
        .then((file) => reader.readAsArrayBuffer(file));
    }
  });
};

export const writeFile = (binaryData: Blob | ArrayBuffer | Uint8Array, type: string, fileName: string) => {
  const blob = !(binaryData instanceof Blob) ? new Blob([binaryData], { type }) : binaryData;

  const url = window.URL.createObjectURL(blob);

  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = fileName;

  document.body.appendChild(anchor);
  anchor.click();

  window.URL.revokeObjectURL(url);
  document.body.removeChild(anchor);
};

// 확장자까지 포함한 원본 파일명 그대로 내려받기
export const downloadFileAs = async (url: string, fileName: string) => {
  const response = await axios.get(url, { responseType: 'blob' });
  writeFile(response.data, response.data.type, fileName);
};

export const downloadFile = (url?: string, fileName?: string) => {
  if (!url) return;

  const ext = url.split('.').pop();
  let aLink = document.createElement('a');

  if (!ext) return;

  axios
    .get(url, { responseType: 'blob' })
    .then((response) => {
      const fileUrl = window.URL.createObjectURL(new Blob([response.data]));

      let aLink = document.createElement('a');
      aLink.href = fileUrl;
      if (fileName) {
        aLink.download = `${fileName}.${ext}`;
      }
      document.body.appendChild(aLink);
      aLink.click();

      // clean
      document.body.removeChild(aLink);
      window.URL.revokeObjectURL(fileUrl);
    })
    .catch((err) => {
      // 리네이밍 하지 않는 기존 링크 다운로드로 재시도
      aLink.href = url;
      document.body.appendChild(aLink);
      aLink.click();
      document.body.removeChild(aLink);
    });
};
